import React from 'react'
import {Button, FormControlLabel, Stack, Switch} from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
// import IconButton from "@mui/material/IconButton";


interface ControlProps {
    sum: number
    isScanStart: boolean
    toggleScan: () => void
    saveBasket: () => void
    deleteBasket: () => void
    basketID: string
}
const Control:React.FC<ControlProps> = ({sum,basketID,  isScanStart, toggleScan, saveBasket, deleteBasket}) =>  {
   return <>
   {/*    <Stack direction="row" alignItems={"center"} spacing={2} justifyContent="space-between" padding={1.5}>*/}
   {/*    <FormControlLabel control={*/}
   {/*        <Switch defaultChecked={isScanStart}  onClick={toggleScan}/>*/}
   {/*    } label="быстрое добавление" />*/}
   {/*</Stack>*/}
       <Stack direction="row" alignItems={"center"} spacing={2} justifyContent={"space-between"} padding={1.5}>
           <Button onClick={deleteBasket} variant="contained" size='small' color="error"><CancelIcon/></Button>
           <strong>{sum} р.</strong> {basketID.length >0 && <strong>ид корзины: {basketID} </strong>}
           <Button onClick={saveBasket} variant="contained" size='small'><SaveIcon/></Button>
       </Stack></>
}
export default Control;